import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { timecardFeatureKey, timecardReducer } from './timecard.reducer';
import { TimecardEffects } from './timecard.effects';
import { EnvironmentProviders } from '@angular/core';

export const provideTimecardStore = (): EnvironmentProviders[] => [
    provideState(timecardFeatureKey, timecardReducer),
    provideEffects(TimecardEffects)
];
